export default __webpack_public_path__ + "static/media/contact.6a36f7f4.svg";